import {
  BreakpointsPx,
  colors,
  Icons,
  ImpButton,
  ImpContainer,
  ImpHidden,
  ImpInlineLink,
  ImpModal,
  ImpText,
  useModal,
} from '@imprint-payments/imprint-ui';

import { EVENT } from '../../analytics/analyticsConsts';
import { ENV } from '../../app/apiScreenSlice';
import { useImpState } from '../../app/hooks';
import { ANALYTICS } from '../../firebase/firebase';
import { getEnv } from '../../utils/environments';
import { getOfferUUIDs } from '../../utils/functionUtils';
import RewardsModal from './RewardsModal';

export const getAccountLink = (domain: string): string => {
  let toNavigate: string = 'https://account.imprint.co';
  const env = getEnv(domain)[0];
  if (env === ENV.STG || env === ENV.LOCAL) {
    toNavigate = 'https://account.stg.imprintapi.co';
  }
  if (env === ENV.PREPRD) {
    toNavigate = 'https://account.preprd.imprintapi.co';
  }

  return toNavigate;
};

export function TrailingContent({
  showRewardsButton = false,
}: {
  showRewardsButton?: boolean;
}) {
  const breakpointToggle = BreakpointsPx.Application;
  return (
    <>
      <AlreadyAppliedText breakpoint={breakpointToggle} />
      {showRewardsButton && <RewardsTrigger breakpoint={breakpointToggle} />}
    </>
  );
}

function AlreadyAppliedText({ breakpoint }: { breakpoint: number }) {
  const { language } = useImpState();

  return (
    <ImpContainer textAlign="right">
      <ImpHidden hideBelow={breakpoint}>
        <ImpText typography="body3" color={colors.content.onBackgroundVariant}>
          <ImpInlineLink
            url={getAccountLink(window.location.hostname.toLowerCase())}
            color="var(--merchant-color)"
            onClick={() =>
              ANALYTICS.logEvent(EVENT.APPLICATION_ALREADY_APPLIED_CLICKED)
            }
          >
            {language.checkApplicationStatusHeader}
          </ImpInlineLink>
        </ImpText>
      </ImpHidden>
    </ImpContainer>
  );
}

export function RewardsTrigger({ breakpoint }: { breakpoint: number }) {
  const { language } = useImpState();
  const [
    isRewardsModalOpen,
    isRewardsModalClosing,
    openRewardsModal,
    closeRewardsModal,
  ] = useModal(false);

  return (
    <ImpContainer textAlign="right">
      <ImpHidden hideAbove={breakpoint}>
        <ImpButton
          buttonStyle="color"
          variant="text"
          color="var(--merchant-color)"
          onClick={() => {
            openRewardsModal();
            ANALYTICS.logEvent(EVENT.APPLICATION_REWARDS_CLICKED, {
              offer_config_uuids: (getOfferUUIDs() ?? []).join(','),
            });
          }}
          trailingIcon={Icons.chevronDown}
        >
          {language.rewards}
        </ImpButton>
      </ImpHidden>
      <ImpModal
        isOpen={isRewardsModalOpen}
        isClosing={isRewardsModalClosing}
        closeModal={() => {
          closeRewardsModal();
        }}
        stickyHeader
        headerText={language.rewards}
      >
        <ImpContainer backgroundColor={colors.surface.surfaceMid} width="100%">
          <ImpContainer width="100%" textAlign="center">
            <RewardsModal />
          </ImpContainer>
        </ImpContainer>
      </ImpModal>
    </ImpContainer>
  );
}
